import { render } from "./CookieSettingsPanel.vue?vue&type=template&id=0a46b4c5&scoped=true"
import script from "./CookieSettingsPanel.vue?vue&type=script&lang=js"
export * from "./CookieSettingsPanel.vue?vue&type=script&lang=js"

import "./CookieSettingsPanel.vue?vue&type=style&index=0&id=0a46b4c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a46b4c5"]])

export default __exports__